//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'section-widget',
  components: {},
  props: {
    widget: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object
  },
  data: function data() {
    return {
      gridLayout: [{
        x: 0,
        y: 0,
        w: 4,
        h: 4,
        i: '0'
      }]
    };
  },
  methods: {
    checkContainerMove: function checkContainerMove(evt) {
      return this.designer.checkWidgetMove(evt);
    },
    onDragEnd: function onDragEnd(obj, subList) {
      //
    },
    onDragAdd: function onDragAdd(evt, subList) {
      //重复代码，可合并
      debugger;
      var newIndex = evt.newIndex;
      if (!!subList[newIndex]) {
        this.designer.setSelected(subList[newIndex]);
      }
      this.designer.emitHistoryChange();
      this.designer.emitEvent('field-selected', this.widget);
    },
    onDragUpdate: function onDragUpdate() {
      this.designer.emitHistoryChange();
    },
    onDragCallback: function onDragCallback(x, y) {
      this.widget.options.x = x;
      this.widget.options.y = y;
      console.error('x, y', x + ', ' + y);
      this.designer.emitHistoryChange();
    },
    onResizeCallback: function onResizeCallback(x, y, width, height) {
      this.widget.options.x = x;
      this.widget.options.y = y;
      this.widget.options.w = width;
      this.widget.options.h = height;
      console.error('w, h', width + ', ' + height);
      this.designer.emitHistoryChange();
    }
  }
};